import { useQuery } from '@tanstack/react-query';
import {
  portalProfilesApi,
  type FindPortalProfilesResponse,
  type ListDisconnectedProfilesResponse,
  type ListPortalProfilesResponse,
  type PortalHomeResponse,
} from '../infrastructure/portalProfiles.api';

// Query keys for the portal profiles feature. Commands invalidate against `all` so reads refetch after a write.
export const profileKeys = {
  all: ['portal-profiles'] as const,
  home: () => ['portal-profiles', 'home'] as const,
  list: () => ['portal-profiles', 'list'] as const,
  found: () => ['portal-profiles', 'found'] as const,
  disconnected: () => ['portal-profiles', 'disconnected'] as const,
};

/** Read — the home summary (active profile + claimed profiles). */
export function usePortalHomeQuery() {
  return useQuery<PortalHomeResponse>({
    queryKey: profileKeys.home(),
    queryFn: () => portalProfilesApi.home(),
  });
}

/** Read — the user's claimed profiles (family members) + active selection. */
export function usePortalProfilesQuery() {
  return useQuery<ListPortalProfilesResponse>({
    queryKey: profileKeys.list(),
    queryFn: () => portalProfilesApi.list(),
  });
}

/** Read — claim candidates matching the user's verified contact (not yet claimed). */
export function useFoundProfilesQuery(enabled = true) {
  return useQuery<FindPortalProfilesResponse>({
    queryKey: profileKeys.found(),
    queryFn: () => portalProfilesApi.found(),
    enabled,
  });
}

/** Read — the user's Disconnected links (read-only history; disconnection is terminal). */
export function useDisconnectedProfilesQuery() {
  return useQuery<ListDisconnectedProfilesResponse>({
    queryKey: profileKeys.disconnected(),
    queryFn: () => portalProfilesApi.disconnected(),
  });
}
